import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function  isAllowedPermission(allowedPermissions:string[]|undefined, permission:string) {
  // return true
  return allowedPermissions?.includes(permission)
}


export const stringToColor = (str: string): string => {
  let hash = 0;
  
  // Generate a hash from the string
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Convert hash to HEX color
  let color = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    color += value.toString(16).padStart(2, "0");
  }

  return color;
};

